import { FC, useEffect } from 'react';

import { Page } from 'src/components/Page/Page';
import { RoutePath } from 'src/routes/types';
import { navigationActions } from 'src/store/navigation/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { CreateSpaceButton } from './SpaceDialog/CreateSpaceButton';
import { SpaceDialog } from './SpaceDialog/SpaceDialog';
import { SpaceDialogProvider } from './SpaceDialog/SpaceDialogProvider';
import { SearchSpace } from './SpacesList/SearchSpace';
import { SpacesList } from './SpacesList/SpacesList';
import { SpacesProvider, useSpaces } from './SpacesList/SpacesProvider';
import classes from './SpacesPage.module.scss';

const Inner: FC = () => {
  const { deleteSpaceDialog } = useSpaces();

  return (
    <>
      {deleteSpaceDialog}
      <SpaceDialog />
      <SpacesList />
    </>
  );
};

export const SpacesPage: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(navigationActions.setSegments([RoutePath.Main, RoutePath.Spaces]));
  }, [dispatch]);

  return (
    <SpacesProvider>
      <SpaceDialogProvider>
        <Page
          actions={
            <div className={classes.actions}>
              <div className={classes.leftActions}>
                <SearchSpace />
              </div>
              <CreateSpaceButton className={classes.rightActions} />
            </div>
          }
          testId='spaces'
        >
          <Inner />
        </Page>
      </SpaceDialogProvider>
    </SpacesProvider>
  );
};

export default SpacesPage;
